/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiLink from '@material-ui/core/Link';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import moment from 'moment';
import {
  invoiceOtherQuarterCells,
  invoiceDrugActivityCells,
} from './gridComponents/tableHead';
import {
  getInvoiceOtherQuarter,
  setInvoiceOtherQtrIndex,
  setInvoiceOtherHideZeroBalance,
  setInvoiceOtherSelectedQtr,
} from '../store/actions';
import LinksButtonRender from './linksButtonRender';
import {
  currencyFormatter,
  formatQuater,
  getCommonDropdownList,
  validateQuarter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const useStyles = makeStyles((theme) => ({
  root: { '& > * + *': { marginLeft: theme.spacing(2) } },
  input: {
    '&:disabled': {
      color: 'red!important',
    },
  },
}));
const Link = withStyles({
  root: {
    '&[disabled]': {
      color: 'grey!important',
      cursor: 'default',
      '&:hover': { textDecoration: 'none' },
    },
  },
})(MuiLink);

export default function InvoiceOtherQuarterTab({
  invoiceDetailsByInvoiceNum,
  setFullScreenView,
  fullScreenView,
  commonDropdownList,
  invoiceReasonList,
}) {
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);

  const drugActivity = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.drugActivity
  );
  const invoiceOtherQuarter = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceOtherQuarter
  );

  const invoiceOtherQtrIndex = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceOtherQtrIndex
  );

  const [invoiceQtrNumber, setInvoiceQtrNumber] = useState(
    invoiceOtherQuarter?.wrapperRespVOs?.[invoiceOtherQtrIndex || 0]
      ?.currInvoiceBalanceResponse?.qtr
  );

  const [invoiceBalance, setInvoiceBalance] = useState(
    invoiceOtherQuarter?.wrapperRespVOs?.[invoiceOtherQtrIndex || 0]
      ?.currInvoiceBalanceResponse?.invoiceBalance
  );

  const [rowData, setRowData] = useState([]);
  const [otherQtrDataTemp, setOtherQtrDataTemp] = useState([]);
  const hideZeroBalanceRedux = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceOther_hideZeroBalance
  );
  const selectedQtrRedux = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceOther_selectedQtr
  );

  const [hideZeroBalance, setHideZeroBalance] = useState(hideZeroBalanceRedux ?? true);
  const [isNextDisable, setIsNextDisable] = useState(false);
  const [isPrevDisable, setIsPrevDisable] = useState(false);
  const [drugActivityList, setDrugActivityList] = React.useState([]);
  const [rowIndex, setRowIndex] = useState(invoiceOtherQtrIndex || 0);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState('');
  const [filterApply, setFilterApply] = React.useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApplyDrugActive, setFilterApplyDrugActive] =
    React.useState(false);
  const [filteredRowsDrugActive, setFilteredRowDrugActive] = React.useState([]);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const getFilterApplyDrugActive = (filterApplied1) => {
    setFilterApplyDrugActive(filterApplied1);
  };
  React.useEffect(() => {
    const adjustmentObj = commonDropdownList?.ADJUSTMENT_DISPUTE_CD;
    const activityObj = commonDropdownList?.ACTIVITY_TYPE_CD;

    if (drugActivity?.data?.length > 0) {
      const newObj = drugActivity.data.map((item) => {
        if (
          adjustmentObj?.filter((x) => {
            return x.codeValueID && x.codeValueID?.codeValue === item.disputeCd;
          })?.length > 0
        ) {
          const disputeObj = adjustmentObj?.filter((x) => {
            return x.codeValueID && x.codeValueID?.codeValue === item.disputeCd;
          });
          item.disputeCd = `${
            disputeObj[0].codeValueID && disputeObj[0].codeValueID.codeValue
          } | ${disputeObj[0].shortDescription}`;
        }
        if (
          activityObj?.filter((x) => {
            return (
              x.codeValueID &&
              x.codeValueID?.codeValue === item.drugActivityTypeCd
            );
          })?.length > 0
        ) {
          const ActivityObjList = activityObj?.filter((x) => {
            return (
              x.codeValueID &&
              x.codeValueID?.codeValue === item.drugActivityTypeCd
            );
          });
          item.drugActivityTypeCd = `${
            ActivityObjList[0].codeValueID &&
            ActivityObjList[0].codeValueID.codeValue
          } | ${ActivityObjList[0].shortDescription}`;
        }

        return item;
      });
      setDrugActivityList(newObj);
    }
  }, [drugActivity?.data]);
  const frameworkComponents = {
    LinksButtonRender: LinksButtonRender,
  };
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rowData;
    const data = displayedRows?.reduce((accumulator, object) => {
      return accumulator + parseFloat(object[property] || 0);
    }, 0);
    if (property === 'disputedUnits' || property === 'paidUnits') {
      return parseFloat(data)?.toFixed(4);
    }
    if (property === 'unitRebateAmt') {
      return parseFloat(data)?.toFixed(6);
    }
    if (property === 'numOfUnits') {
      return parseFloat(data)?.toFixed(3);
    }
    return Math.round(100 * data) / 100;
  };
  const onFilterChangedDrugActive = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRowDrugActive(updatedRowData);
  };
  const sum1 = (property) => {
    const displayedRows = filterApplyDrugActive
      ? filteredRowsDrugActive
      : drugActivityList;
    const data = displayedRows?.reduce((accumulator, object) => {
      return accumulator + parseFloat(object[property] || 0);
    }, 0);
    if (property === 'disputedUnits' || property === 'paidUnits') {
      return parseFloat(data)?.toFixed(4);
    }
    if (property === 'unitRebateAmt') {
      return parseFloat(data)?.toFixed(6);
    }
    if (property === 'numOfUnits') {
      return parseFloat(data)?.toFixed(3);
    }
    if (property === 'changeNumOfUnits') {
      return parseFloat(data || 0)?.toFixed(2);
    }
    return Math.round(100 * data) / 100;
  };
  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        rowPinned: true,
        isBottomRow: true,
        totalDue: sum('totalDue'),
        interestCalculatedAmt: sum('interestCalculatedAmt'),
        principleDue: sum('principleDue'),
        priorPaidAmt: sum('priorPaidAmt'),
        revisedInvAmt: sum('revisedInvAmt'),
        origInvAmt: sum('origInvAmt'),
        disputedUnits: sum('disputedUnits'),
        paidUnits: sum('paidUnits'),
        numOfUnits: sum('numOfUnits'),
        // unitRebateAmt: sum('unitRebateAmt'),
      });
    }
    return result;
  };
  const createData1 = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        rowPinned: true,
        isBottomRow: true,
        changeAmt: sum1('changeAmt'),
        numOfUnits: sum1('numOfUnits'),
        unitRebateAmt: sum1('unitRebateAmt'),
        changeNumOfUnits: sum1('changeNumOfUnits'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rowData, filteredRows, filterApply]);
  const pinnedBottomRowData1 = useMemo(() => {
    return createData1(1, 'Bottom');
  }, [drugActivityList, filteredRowsDrugActive, filterApplyDrugActive]);
  const toggleZeroBal = () => {
  const next = !hideZeroBalance;
  setHideZeroBalance(next);
  dispatch(setInvoiceOtherHideZeroBalance(next));
  };

  const handleOtherInvoiceQtrClick = (e) => {
    if (!otherQtrDataTemp || otherQtrDataTemp.length === 0) return;

    if (e.target.name === 'next') {
      const newIndex = Math.min(rowIndex + 1, otherQtrDataTemp.length - 1);
      const item = otherQtrDataTemp[newIndex];
      setRowIndex(newIndex);
      setRowData(item?.invoiceOtherQtrResponseVOs || []);
      setInvoiceQtrNumber(item?.currInvoiceBalanceResponse?.qtr || '');
      setInvoiceBalance(item?.currInvoiceBalanceResponse?.invoiceBalance ?? null);
      dispatch(setInvoiceOtherQtrIndex(newIndex));
    } else if (e.target.name === 'prev') {
      const newIndex = Math.max(rowIndex - 1, 0);
      const item = otherQtrDataTemp[newIndex];
      setRowIndex(newIndex);
      setRowData(item?.invoiceOtherQtrResponseVOs || []);
      setInvoiceQtrNumber(item?.currInvoiceBalanceResponse?.qtr || '');
      setInvoiceBalance(item?.currInvoiceBalanceResponse?.invoiceBalance ?? null);
      dispatch(setInvoiceOtherQtrIndex(newIndex));
    }
  };

  const setInvoiceOtherQuarterData = (value) => {
    const index = otherQtrDataTemp.findIndex(
      (data) => data.currInvoiceBalanceResponse.qtr === value
    );
    
    if (index >= 0) {
      setRowIndex(index);
      setRowData(otherQtrDataTemp[index]?.invoiceOtherQtrResponseVOs);
      setInvoiceQtrNumber(value);
      setInvoiceBalance(
        otherQtrDataTemp[index]?.currInvoiceBalanceResponse?.invoiceBalance
      );
      dispatch(setInvoiceOtherQtrIndex(index));
      dispatch(setInvoiceOtherSelectedQtr(value));
    } else {
      setOpen(true);
      setModalMsg(`There is no data for this quarter - ${value}.`);
    }
  };

  useEffect(() => {
  if (!invoiceOtherQuarter?.wrapperRespVOs || invoiceOtherQuarter.wrapperRespVOs.length === 0) {
      dispatch(
        getInvoiceOtherQuarter({
          qtr: invoiceDetailsByInvoiceNum?.qtr,
          mfgId: invoiceDetailsByInvoiceNum?.mfgId,
          rebateProgramCd: invoiceDetailsByInvoiceNum?.rebateProgramCd,
          invoiceReasonCd: 'CR',
          invoiceNum: invoiceDetailsByInvoiceNum?.invoiceNum,
        })
      );
    }
  }, []);

  useEffect(() => {
    const wrappers = invoiceOtherQuarter?.wrapperRespVOs || [];
    
    const invoiceToDisplayOn = hideZeroBalance
      ? wrappers.filter(
          (qtrData) =>
            qtrData?.currInvoiceBalanceResponse?.invoiceBalance != null &&
            parseFloat(qtrData.currInvoiceBalanceResponse.invoiceBalance) !== 0
        )
      : [...wrappers];


    setOtherQtrDataTemp(invoiceToDisplayOn);

    if (invoiceToDisplayOn.length > 0) {
      let idx = typeof invoiceOtherQtrIndex === 'number' ? invoiceOtherQtrIndex : 0;

      if ((idx === undefined || idx === null || idx === 0) && selectedQtrRedux) {
        const storedIndex = invoiceToDisplayOn.findIndex((d) => d?.currInvoiceBalanceResponse?.qtr === selectedQtrRedux);
        if (storedIndex >= 0) idx = storedIndex;
      }

      if (idx < 0 || idx >= invoiceToDisplayOn.length) idx = 0;

      setRowIndex(idx);
      setRowData(invoiceToDisplayOn[idx]?.invoiceOtherQtrResponseVOs || []);
      setInvoiceQtrNumber(invoiceToDisplayOn[idx]?.currInvoiceBalanceResponse?.qtr || '');
      setInvoiceBalance(invoiceToDisplayOn[idx]?.currInvoiceBalanceResponse?.invoiceBalance ?? null);
    } else {
      setRowIndex(0);
      setRowData([]);
      setInvoiceQtrNumber('');
      setInvoiceBalance(null);
    }
  }, [invoiceOtherQuarter, hideZeroBalance, invoiceOtherQtrIndex]);

  useEffect(() => {
    if (typeof hideZeroBalanceRedux === 'boolean' && hideZeroBalanceRedux !== hideZeroBalance) {
      setHideZeroBalance(hideZeroBalanceRedux);
    }
  }, [hideZeroBalanceRedux]);

  useEffect(() => {
    const total = otherQtrDataTemp?.length || 0;
    setIsPrevDisable(rowIndex <= 0 || total === 0);
    setIsNextDisable(total <= 1 || rowIndex >= total - 1);
  }, [rowIndex, otherQtrDataTemp]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.drugSeqNum;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        INVOICE_NUM: invoiceDetailsByInvoiceNum.invoiceNum,
      });
    }
  };

  const classes = useStyles();
  return (
    <>
      <CommonModal
        open={open}
        data-testid="comman_modal1"
        viewAction
        viewHeader
        className="dialogPanel frr-rightAlignment custom-check dialog-420"
        onOk={() => setOpen(false)}
        okTitle="Ok"
        onClose={() => {
          setOpen(false);
        }}
        modalTitle="Display Invoice"
        childrenComponent={
          <div>
            <p>{modalMsg}</p>
          </div>
        }
      />
      <div style={{ marginTop: '0px' }}>
        {!fullScreenView && (
          <div className="invoice_details outline_auto_height">
            <div className="form-wrapper">
              <div className="mui-custom-form with-select input-md mui-custom-form-with-margin ">
                <div style={{ marginTop: 10 }}>
                  <Link
                    component="button"
                    variant="body2"
                    name="prev"
                    onClick={handleOtherInvoiceQtrClick}
                    className="Prev-Links"
                    disabled={isPrevDisable}
                  >
                    &laquo;Prev
                  </Link>
                </div>
                <TextField
                  label="Invoice Quarter"
                  fullWidth
                  required
                  placeholder=""
                  id="invoice_quarter"
                  name="quarter"
                  value={invoiceQtrNumber}
                  onChange={(e) => {
                    setInvoiceQtrNumber(e.target.value);
                  }}
                  onBlur={(e) => {
                    let value = e.target?.value;
                    if (value && validateQuarter(value)) {
                      value = formatQuater(value);
                    }
 
                    setInvoiceOtherQuarterData(value);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 6,
                  }}
                />
                <div style={{ marginTop: 10 }}>
                  <Link
                    component="button"
                    variant="body2"
                    name="next"
                    onClick={handleOtherInvoiceQtrClick}
                    className="Next-Links"
                    disabled={isNextDisable}
                  >
                    Next&raquo;
                  </Link>
                </div>
              </div>
              <div
                className={`mui-custom-form with-select input-md mui-custom-form-with-margin1 frr-text-right ${
                  invoiceBalance !== null && parseFloat(invoiceBalance) < 0
                    ? 'negativeValue'
                    : 'positiveValue'
                }`}
              >
                <TextField
                  id="current_invoice_balance"
                  label="Current Invoice Balance"
                  fullWidth
                  placeholder=""
                  value={currencyFormatter(invoiceBalance, '$')}
                  disabled
                  inputProps={{
                    className: invoiceBalance < 0 ? classes.input : null,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className="mui-custom-form with-select input-md mui-custom-form-with-margin2 ">
                <div
                  className="sub-radio text-black sub-label"
                  style={{ marginTop: 23 }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={hideZeroBalance}
                        name="hideZeroBalance"
                        onChange={(e) => {
                          toggleZeroBal(e);
                        }}
                      />
                    }
                    label="Hide Zero Balance Quarters"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="frr-tbl-with-feature">
          <Grid
            gridHeight={fullScreenView ? '100vh' : 350}
            rowData={
              rowData?.map((item) => {
                const ActivityObjList = invoiceReasonList?.filter((x) => {
                  return (
                    x.codeValueID &&
                    x.codeValueID?.codeValue === item.invoiceReasonCd
                  );
                });
                return {
                  ...item,
                  unitRebateAmt: item.unitRebateAmt
                    ? parseFloat(item.unitRebateAmt)?.toFixed(4)
                    : '0.0000',
                  numOfUnits: item.numOfUnits
                    ? parseFloat(item.numOfUnits)?.toFixed(4)
                    : '0.0000',
                  paidUnits: item.paidUnits
                    ? parseFloat(item.paidUnits)?.toFixed(4)
                    : '0.0000',
                  disputedUnits: item.disputedUnits
                    ? parseFloat(item.disputedUnits)?.toFixed(4)
                    : '0.0000',
                  origInvAmt: item.origInvAmt
                    ? parseFloat(item.origInvAmt)?.toFixed(2)
                    : '0.00',
                  invoiceReasonCd:
                    ActivityObjList?.length > 0
                      ? `${
                          ActivityObjList[0].codeValueID &&
                          ActivityObjList[0].codeValueID.codeValue
                        } | ${ActivityObjList[0].shortDescription}`
                      : '',
                };
              }) || []
            }
            columnDefs={invoiceOtherQuarterCells}
            data-testid="onEditingStopped"
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            singleClickEdit={false}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenViewClick}
            exportFile
            isScrollOn
            fileName="Other Quarter"
            // handleViewHistory={handleViewHistory}
            frameworkComponents={{
              frameworkComponents,
              AmountComponent: CustomGridCellRendererComponent,
              UnitRebateAmtCellRender: (cellInfo) => {
                const value = parseFloat(cellInfo?.value);
                if (cellInfo?.data?.isBottomRow) {
                  const pinnedValue = parseFloat(cellInfo?.value);
                  if (pinnedValue < 0) {
                    return (
                      <b>
                        <span style={{ color: '#eb0000', display: 'inline' }}>
                          (
                          {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 6,
                              maximumFractionDigits: 6,
                            }
                          )}`}
                          )
                        </span>
                      </b>
                    );
                  }
                  if (pinnedValue) {
                    return (
                      <b>
                        {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                          minimumFractionDigits: 6,
                          maximumFractionDigits: 6,
                        })}`}
                      </b>
                    );
                  }
                  return <b> 0.000000</b>;
                }
                if (value < 0) {
                  return (
                    <span style={{ color: '#eb0000', display: 'inline' }}>
                      (
                      {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                        minimumFractionDigits: 6,
                        maximumFractionDigits: 6,
                      })}
                      )
                    </span>
                  );
                }
                if (value) {
                  return ` ${parseFloat(value)?.toLocaleString('en-US', {
                    minimumFractionDigits: 6,
                    maximumFractionDigits: 6,
                  })}`;
                }
                return ' 0.000000';
              },
              NameRenderCheckIssuer: (cellInfo) => {
                const name = cellInfo?.data?.invoiceReasonCd;
                if (name && name.length > 22) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name?.trim()}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name?.trim()}</div>;
              },
              CurrentURACellRender: (cellInfo) => {
                const value = parseFloat(cellInfo?.value);
                if (cellInfo?.data?.isBottomRow) {
                  // const pinnedValue = parseFloat(cellInfo?.value);
                  // if (pinnedValue < 0) {
                  //   return (
                  //     <b>
                  //       <span style={{ color: '#eb0000' }}>
                  //         (
                  //         {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                  //           'en-US',
                  //           {
                  //             minimumFractionDigits: 4,
                  //             maximumFractionDigits: 4,
                  //           }
                  //         )}`}
                  //         )
                  //       </span>
                  //     </b>
                  //   );
                  // }
                  // if (pinnedValue) {
                  //   return (
                  //     <b>
                  //       {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                  //         minimumFractionDigits: 4,
                  //         maximumFractionDigits: 4,
                  //       })}`}
                  //     </b>
                  //   );
                  // }
                  return '';
                }
                if (value < 0) {
                  return (
                    <span style={{ color: '#eb0000', display: 'inline' }}>
                      (
                      {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                        minimumFractionDigits: 4,
                        maximumFractionDigits: 4,
                      })}
                      )
                    </span>
                  );
                }
                if (value) {
                  return ` ${parseFloat(value)?.toLocaleString('en-US', {
                    minimumFractionDigits: 4,
                    maximumFractionDigits: 4,
                  })}`;
                }
                return ' 0.0000';
              },
              NumOfUnitsCellRender: (cellInfo) => {
                const value = parseFloat(cellInfo?.value);
                if (cellInfo?.data?.isBottomRow) {
                  const pinnedValue = parseFloat(cellInfo?.value);
                  if (pinnedValue < 0) {
                    return (
                      <b>
                        <span style={{ color: '#eb0000', display: 'inline' }}>
                          (
                          {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }
                          )}`}
                          )
                        </span>
                      </b>
                    );
                  }
                  if (pinnedValue) {
                    return (
                      <b>
                        {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                          minimumFractionDigits: 1,
                          maximumFractionDigits: 1,
                        })}`}
                      </b>
                    );
                  }
                  return <b> 0.0</b>;
                }
                if (value < 0) {
                  return (
                    <span style={{ color: '#eb0000', display: 'inline' }}>
                      (
                      {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                      })}
                      )
                    </span>
                  );
                }
                if (value) {
                  return ` ${parseFloat(value)?.toLocaleString('en-US', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  })}`;
                }
                return ' 0.0';
              },
              nameRenderOtherDrugName: (cellInfo) => {
                const name = cellInfo.data && cellInfo.data.drugName;
                if (name && name.length > 23) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
              nameRenderOtherNdc: (cellInfo) => {
                const name = cellInfo.data && cellInfo.data.ndc;
                if (name && name.length > 10) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
            pinnedBottomRowData={pinnedBottomRowData}
            onFilterData={onFilterChanged}
            getFilterApply={getFilterApply}
            hideColumnsInPdf={['actions']}
          />
        </div>
        {drugActivity?.data ? (
          <div style={{ marginTop: '5px' }}>
            <Grid
              gridHeight={fullScreenView ? '100vh' : 350}
              rowData={
                rowData?.length > 0 && drugActivityList?.length > 0
                  ? drugActivityList?.map((item) => {
                      item.numOfUnits = item.numOfUnits
                        ? parseFloat(item.numOfUnits).toFixed(4)
                        : parseFloat(0).toFixed(4);
                      item.unitRebateAmt = item.unitRebateAmt
                        ? parseFloat(item.unitRebateAmt).toFixed(6)
                        : parseFloat(0).toFixed(6);
                      item.changeNumOfUnits = item.changeNumOfUnits
                        ? parseFloat(item.changeNumOfUnits || 0).toFixed(2)
                        : parseFloat(0).toFixed(2);
                      item.changeAmt = item.changeAmt
                        ? parseFloat(item.changeAmt).toFixed(2)
                        : parseFloat(0).toFixed(2);
                      return item;
                    })
                  : []
              }
              columnDefs={invoiceDrugActivityCells}
              data-testid="onEditingStopped"
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              singleClickEdit={false}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenViewClick}
              exportFile
              isScrollOn
              fileName="Other Quarter"
              handleViewHistory={handleViewHistory}
              frameworkComponents={{
                frameworkComponents,
                AmountComponent: CustomGridCellRendererComponent,
                UnitRebateAmtCellRender: (cellInfo) => {
                  const value = parseFloat(cellInfo?.value);
                  if (cellInfo?.data?.isBottomRow) {
                    const pinnedValue = parseFloat(cellInfo?.value);
                    if (pinnedValue < 0) {
                      return (
                        <b>
                          <span style={{ color: '#eb0000', display: 'inline' }}>
                            (
                            {` ${Math.abs(
                              parseFloat(pinnedValue)
                            ).toLocaleString('en-US', {
                              minimumFractionDigits: 6,
                              maximumFractionDigits: 6,
                            })}`}
                            )
                          </span>
                        </b>
                      );
                    }
                    if (pinnedValue) {
                      return (
                        <b>
                          {` ${parseFloat(pinnedValue)?.toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 6,
                              maximumFractionDigits: 6,
                            }
                          )}`}
                        </b>
                      );
                    }
                    return <b> 0.000000</b>;
                  }
                  if (value < 0) {
                    return (
                      <span style={{ color: '#eb0000', display: 'inline' }}>
                        (
                        {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                          minimumFractionDigits: 6,
                          maximumFractionDigits: 6,
                        })}
                        )
                      </span>
                    );
                  }
                  if (value) {
                    return ` ${parseFloat(value)?.toLocaleString('en-US', {
                      minimumFractionDigits: 6,
                      maximumFractionDigits: 6,
                    })}`;
                  }
                  return ' 0.000000';
                },
                ChangeNumOfUnitsCellRender: (cellInfo) => {
                  const value = parseFloat(cellInfo?.value);
                  if (cellInfo?.data?.isBottomRow) {
                    const pinnedValue = parseFloat(cellInfo?.value);
                    if (pinnedValue < 0) {
                      return (
                        <b>
                          <span style={{ color: '#eb0000', display: 'inline' }}>
                            (
                            {` ${Math.abs(
                              parseFloat(pinnedValue)
                            ).toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                            )
                          </span>
                        </b>
                      );
                    }
                    if (pinnedValue) {
                      return (
                        <b>
                          {` ${parseFloat(pinnedValue)?.toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}`}
                        </b>
                      );
                    }
                    return <b> 0.00</b>;
                  }
                  if (value < 0) {
                    return (
                      <span style={{ color: '#eb0000', display: 'inline' }}>
                        (
                        {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        )
                      </span>
                    );
                  }
                  if (value) {
                    return ` ${parseFloat(value)?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`;
                  }
                  return ' 0.00';
                },
                NumOfUnitsCellRender: (cellInfo) => {
                  const value = parseFloat(cellInfo?.value);
                  if (cellInfo?.data?.isBottomRow) {
                    const pinnedValue = parseFloat(cellInfo?.value);
                    if (pinnedValue < 0) {
                      return (
                        <b>
                          <span style={{ color: '#eb0000', display: 'inline' }}>
                            (
                            {` ${Math.abs(
                              parseFloat(pinnedValue)
                            ).toLocaleString('en-US', {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            })}`}
                            )
                          </span>
                        </b>
                      );
                    }
                    if (pinnedValue) {
                      return (
                        <b>
                          {` ${parseFloat(pinnedValue)?.toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            }
                          )}`}
                        </b>
                      );
                    }
                    return <b> 0.000</b>;
                  }
                  if (value < 0) {
                    return (
                      <span style={{ color: '#eb0000', display: 'inline' }}>
                        (
                        {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}
                        )
                      </span>
                    );
                  }
                  if (value) {
                    return ` ${parseFloat(value)?.toLocaleString('en-US', {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}`;
                  }
                  return ' 0.000';
                },
                DrugActivityTypeCdCellRender: (cellInfo) => {
                  const name = cellInfo?.data?.drugActivityTypeCd;
                  if (name && name.length > 22) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              pinnedBottomRowData={pinnedBottomRowData1}
              onFilterData={onFilterChangedDrugActive}
              getFilterApply={getFilterApplyDrugActive}
            />
          </div>
        ) : null}
        {showViewHistory ? (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="INVOICE_HEADER"
            keyValue={keyValue}
          />
        ) : null}
      </div>
    </>
  );
}
